import { isApiError } from '@/lib/api';

/**
 * What the toast says when Call next (or Call) is refused. The API's own
 * wording is kept as the body: it names the branch for QUEUE_EMPTY and the
 * ticket in the room for ROOM_OCCUPIED (RL-2176, RL-2177). Every screen that
 * calls a patient uses this, so the same refusal reads the same everywhere.
 */
export function callNextFailure(
  err: unknown,
  t: (key: string) => string,
): { title: string; body?: string } {
  if (!isApiError(err)) return { title: t('queue.notDone') };
  const title =
    err.code === 'ROOM_OCCUPIED'
      ? t('queue.roomOccupied')
      : (err.problem?.title ?? t('queue.notDone'));
  return { title, body: err.message };
}
